__turbopack_context__.v({
  "Section": "styles-module__pkuZka__Section",
  "Section-inner": "styles-module__pkuZka__Section-inner",
});
